const mockRepos = [
    {
        login: "Rafael-Yokoyama",
        id: 60978293,
        node_id: "MDQ6VXNlcjYwOTc4Mjkz",
        avatar_url: "https://avatars.githubusercontent.com/u/60978293?v=4",
        gravatar_id: "",
        url: "https://api.github.com/users/Rafael-Yokoyama",
        html_url: "https://github.com/Rafael-Yokoyama",
        followers_url: "https://api.github.com/users/Rafael-Yokoyama/followers",
        following_url: "https://api.github.com/users/Rafael-Yokoyama/following{/other_user}",
        repos_url: "https://api.github.com/users/Rafael-Yokoyama/repos",
        received_events_url: "https://api.github.com/users/Rafael-Yokoyama/received_events",
        type: "User",
        company: "Universidade São Francisco ",
        blog: "https://portfolioyokoyama.netlify.app/",
        location: "Itatiba,São Paulo ",
        bio: "Hello,  I'm Rafael! Front-end Jr dev with focus on web development. 🙃 ",
        twitter_username: null,
        public_repos: 42,
        public_gists: 0,
        followers: 62,
        following: 77,
        
      }
 

    ]
  
    export default mockRepos;